// The CSRF cookie is intentionally readable so browser writes can echo it in a header.
// Read it for each request: a safe GET may issue or rotate the cookie after page load.
export function readCsrfToken() {
  if (typeof document === 'undefined') return null;

  const cookie = document.cookie
    .split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith('csrf-token='));

  return cookie ? cookie.slice('csrf-token='.length) || null : null;
}
